"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFeatureFlagDto = instanceOfFeatureFlagDto;
exports.FeatureFlagDtoFromJSON = FeatureFlagDtoFromJSON;
exports.FeatureFlagDtoFromJSONTyped = FeatureFlagDtoFromJSONTyped;
exports.FeatureFlagDtoToJSON = FeatureFlagDtoToJSON;
exports.FeatureFlagDtoToJSONTyped = FeatureFlagDtoToJSONTyped;
const FeatureFlagFacilityDto_1 = require("./FeatureFlagFacilityDto");
/**
 * Check if a given object implements the FeatureFlagDto interface.
 */
function instanceOfFeatureFlagDto(value) {
    if (!('key' in value) || value['key'] === undefined)
        return false;
    if (!('isActiveForAll' in value) || value['isActiveForAll'] === undefined)
        return false;
    if (!('activeFacilities' in value) || value['activeFacilities'] === undefined)
        return false;
    return true;
}
function FeatureFlagDtoFromJSON(json) {
    return FeatureFlagDtoFromJSONTyped(json, false);
}
function FeatureFlagDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'key': json['key'],
        'isActiveForAll': json['isActiveForAll'],
        'activeFacilities': (json['activeFacilities'].map(FeatureFlagFacilityDto_1.FeatureFlagFacilityDtoFromJSON)),
    };
}
function FeatureFlagDtoToJSON(json) {
    return FeatureFlagDtoToJSONTyped(json, false);
}
function FeatureFlagDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'key': value['key'],
        'isActiveForAll': value['isActiveForAll'],
        'activeFacilities': (value['activeFacilities'].map(FeatureFlagFacilityDto_1.FeatureFlagFacilityDtoToJSON)),
    };
}
//# sourceMappingURL=FeatureFlagDto.js.map